import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
declare var Snackbar, $, App, download;
@Injectable({
  providedIn: 'root'
})
export class AlertsService {

  constructor(private router: Router) {

  }

  showToast(text, alertType = 'default') {
    let backgroundColor = '#f57c00';
    switch (alertType) {
      case 'error':
        backgroundColor = '#e7515a';
        break;
      case 'warning':
        backgroundColor = '#e2a03f';
        break;
      case 'info':
        backgroundColor = '#2196f3';
        break;
      case 'success':
        backgroundColor = '#35A037';
        break;
      case 'default':
        backgroundColor = '#f57c00';
        break;
      default:
        break;
    }
    if (text && ((text.includes('Session Expired') || (text.includes('401 OK')|| (text.includes('401 Unauthorized')))))) 
    {
      text = 'Session Expired';
      Snackbar.show({ text, actionTextColor: '#fff', backgroundColor, pos: 'bottom-center' });
      setTimeout(() => {
        localStorage.removeItem(environment.tokenKey);
        this.router.navigate(['/']);
        window.location.href = window.location.href;
      }, 1000)
    }
    else 
    {
      Snackbar.show({ text, actionTextColor: '#fff', backgroundColor, pos: 'bottom-center' });
    }
  }

  loader(text = 'Please wait'): Promise<String> {
    return new Promise((resolve, reject) => {
      $.blockUI({
        message: `<span class="text-semibold"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-loader spin position-left"><line x1="12" y1="2" x2="12" y2="6"></line><line x1="12" y1="18" x2="12" y2="22"></line><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line><line x1="2" y1="12" x2="6" y2="12"></line><line x1="18" y1="12" x2="22" y2="12"></line><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line></svg></i>&nbsp; ${text}</span>`,
        fadeIn: 800,
        timeout: 1000, //unblock after 2 seconds
        overlayCSS: {
          backgroundColor: '#1b2024',
          opacity: 0.8,
          zIndex: 1200,
          cursor: 'wait'
        },
        css: {
          border: 0,
          color: '#fff',
          zIndex: 1201,
          padding: 0,
          backgroundColor: 'transparent'
        },
        onBlock: () => {
          resolve('')
        }
      });

    })
  }

  base64Convert(files) {
    return new Promise((resolve, reject) => {
      var fr = new FileReader();
      fr.onload = () => {
        resolve(fr.result)
      };
      fr.onerror = (error) => {
        reject('Error: ' + error);
      };
      fr.readAsDataURL(files[0]);
    });
  }

  downloadImage(d, fileName) {
    fetch(d.image)
      .then(res => res.blob())
      .then(blob => {
        const file = new File([blob], d.ext)
        download(file, fileName, d.ext);
      })
  }

  detectFormChanges(form) {
    // form.valueChanges.subscribe(val=>
    // {
    //   console.log("Value "+val);
    // })
    form.statusChanges.subscribe(validity => {
      switch (validity) {
        case "VALID":
          // do 'form valid' action
          break;
        case "INVALID":
          formValidity();
          break;
      }

      formValidity();
    })
  }

  resetVormValidity(form) {
    resetVormValidity()
  }

  loadJqueryFns() {
    setTimeout(() => {
      jqueryFns()
    }, 100)
  }
}

function formValidity() {
  var forms = document.getElementsByClassName('needs-validation');
  var validation = Array.prototype.filter.call(forms, function (form) {
    form.classList.add('was-validated');
    // form.addEventListener('submit', function (event) {
    //   if (form.checkValidity() === false) {
    //     event.preventDefault();
    //     event.stopPropagation();
    //   }
    //   form.classList.add('was-validated');
    // }, false);
  });
}

function resetVormValidity() {
  var forms = document.getElementsByClassName('needs-validation');
  Array.prototype.filter.call(forms, function (form) {
    form.classList.remove('was-validated');
  });
}

function jqueryFns() {
  $(document).ready(function () {
    // App.init();
  });
}
